import { memo, useEffect, useRef, useState } from "react";
import "./EditNodes.css";
import { Button, Input } from "antd";
import propertiesHide from "../../assets/icons/sidebar-hide.svg";
import { useTranslation } from "react-i18next";
import { useNodeDataContext } from "../../context/workbench/DataNodeContext";
import { usePermission } from "../../hooks/usePermission";

const { TextArea } = Input;

const EditNodes = () => {
    const { t } = useTranslation('common');
    const dataNodeContext = useNodeDataContext();
    const { canView, canEdit } = usePermission();

    const [showEditProperties, setShowEditProperties] = useState(false);
    const [newContent, setNewContent] = useState<string>("");
    const textAreaRef = useRef<any>(null);

    const handleOnchange = (e: any) => {
        let input = e?.target?.value
        input = input.replace(/^\s+/, ''); // Remove leading spaces
        input = input.replace(/\s{2,}/g, ' '); // Remove extra spaces
        const filter = input.replace(/[^\x00-\x7F]/g, "") // restricting non-ASCII values,
        setNewContent(filter)
    }

    useEffect(() => {
        if (dataNodeContext?.selectedNodeId) {
            const content = dataNodeContext?.nodeData?.content;
            setNewContent(Array.isArray(content) ? content.join("\n") : content); // Handle array or string
            setShowEditProperties(true);

            setTimeout(() => {
                textAreaRef.current?.focus();
            }, 0);
        } else {
            setShowEditProperties(false);
        }
    }, [dataNodeContext?.nodeData?.content, dataNodeContext?.selectedNodeId]);

    const updateNodeContent = () => {
        const updatedSteps = newContent
            ?.split("\n")
            .map((line) => line.trim())
            .filter((line) => line).join("\n"); // Filter empty lines and trim spaces
        if (dataNodeContext?.nodeData?.label === "stepsNode") {
            if (typeof dataNodeContext?.nodeData?.onStepsUpdate === "function") {
                dataNodeContext?.nodeData?.onStepsUpdate(dataNodeContext?.selectedNodeId, updatedSteps); // Update steps
                closeNodeProperties();
            } else {
                console.error("onStepsUpdate is not defined or not a function");
            }
        } else {
            if (typeof dataNodeContext?.nodeData?.onContentUpdate === "function") {
                dataNodeContext?.nodeData?.onContentUpdate(dataNodeContext?.selectedNodeId, newContent); // Update general content
                closeNodeProperties();
            } else {
                console.error("onContentUpdate is not defined or not a function");
            }
        }
    }

    const closeNodeProperties = () => {
        setShowEditProperties(false);
        dataNodeContext.getNodeData("", "");
    }

    return (
        <div className={showEditProperties ? "edit-nodes-wrapper show" : "edit-nodes-wrapper hide"}>
            <div className="d-flex justify-content-between align-items-center">
                <p className="title">{t('properties')}</p>
                <Button className="close-properties-button">
                    <img src={propertiesHide} alt="closeicon" onClick={closeNodeProperties} />
                </Button>
            </div>
            <TextArea
                ref={textAreaRef}
                placeholder="Enter text here"
                className="edit-section"
                value={newContent}
                readOnly={!(canEdit && canView)}
                onChange={(e: any) => handleOnchange(e)}
            />
            <div className="d-flex justify-content-end align-items-center gap-2 mt-3">
                <Button className="edit-cancel-btn" onClick={closeNodeProperties}>{t('buttons.cancel')}</Button>
                <Button 
                    className="edit-update-btn" 
                    disabled={!(canEdit && canView)} 
                    onClick={updateNodeContent}
                >
                    {t('buttons.update')}
                </Button>
            </div>
        </div>
    )
};

export default memo(EditNodes);